import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function safeHref(href) {
  if (typeof href !== "string") return null;
  if (/^(https?:|mailto:)/i.test(href)) return href;
  return null;
}

function SafeLink({ href, children }) {
  const safe = safeHref(href);
  if (!safe) return <span>{children}</span>;
  return (
    <a href={safe} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

export default function AiMarkdown({ text }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{ a: SafeLink }}
    >
      {text || ""}
    </ReactMarkdown>
  );
}
